// Values are i18n key paths (see bootMachine.stepDescription in src/i18n/locales), not display text.
// Resolve with $t(BOOT_STEP_DESCRIPTION[step]) at render time.
export const BOOT_STEP_DESCRIPTION = {
    '0': 'bootMachine.stepDescription.processTime',
    '1': 'bootMachine.stepDescription.analyzingImage',
    '2': 'bootMachine.stepDescription.loadingImage',
    '3': 'bootMachine.stepDescription.almostDone',
}

export const COMMAND_CODE = {
    CREATE_IMAGE: 0,
    BOOT_MACHINE: 1,
    SHUTDOWN: 2,
    SHUTDOWN_CLONE: 8
}